const supportedMethods = ['GET', 'POST', 'PUT', 'DELETE']

export default class Api{
	constructor(module) {
		this.module = module
		this.apis = {}
	}
	
	format($http){
		Object.assign(this.apis, {
			$http,
			...this.module
		})
	}
}